export default __webpack_public_path__ + "static/media/tree-map-highlighted-icon.a685ac5c.svg";